import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Switch from '@material-ui/core/Switch';
import withStyles from '@material-ui/core/styles/withStyles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
  reduce, and, reject, contains, __,
} from 'ramda';

const style = theme => ({
  rootParent: {
    listStyle: 'none',
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  permissionRow: {
    listStyle: 'none',
    padding: 0,
    margin: '0 0 1rem',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    '&:first-child': {
      flexBasis: '100%',
    },
  },
  display: {
    display: 'block',
  },
  switch: {
    textAlign: 'right',
    paddingTop: '0.8%',
  },
  header: {
    margin: '1rem 0 1rem',
  },
  gutterBottom: {
    marginBottom: '1rem',
  },
  // nested levels for ui
  // tree
  nested1: {
    paddingLeft: '1rem',
  },
  nested2: {
    paddingLeft: '2rem',
  },
  nested3: {
    paddingLeft: '3rem',
  },
  nested4: {
    paddingLeft: '4rem',
  },
});

class Permission extends Component {
  // handleChange = value => e => {
  //   const { onChange } = this.props;
  //   onChange(value, e.target.checked);
  // }
  constructor(props) {
    super(props);
    this.state = {
      checkedA: false,
    };
    this.setHeaderToggle(props.resource.actions);
  }
  componentDidMount() {
    if (typeof this.props.getUpdateAllPermission === 'function') {
      this.props.getUpdateAllPermission(this.updateAllPermission.bind(this));
    }
  }

  updateAllPermission(value) {
    const result = this.handleSelectAllToggleChange(this.props.resource,this.props.readOnly,value,this.props.onChange);
    return result;
  }
  updateChildToggles = async (resource, onChange, event) => await Promise.all(
    resource.actions.map(action => onChange(resource.resource, action.action, event.target.checked)),
  );


  updateSelectAllChildToggles = async (resource, value, onChange) => await Promise.all(
    resource.actions.map(action => onChange(resource.resource, action.action,value)
  ));

  handleSelectAllToggleChange = (resource, readOnly, value, onChange) => {
    const _this = this;
    if (!readOnly) {
      const result = this.updateSelectAllChildToggles(resource,value, onChange);
      result
        .then((values) => {
          const checked = values.map((value) => {
            const enabled = Object.values(value.data);
            return enabled[0].allowed;
          });
          if (reduce(and, true, checked)) {
            _this.setState({ checkedA: true });
          } else {
            _this.setState({ checkedA: false });
          }
        })
        .catch((error) => {
          console.error('Error occurred while setting the permission', error);
        });
      return result;
    }
  };


  handleToggleChange = (resource, readOnly, onChange) => (e) => {
    const _this = this;
    if (!readOnly) {
      const result = this.updateChildToggles(resource, onChange, event);
      result
        .then((values) => {
          const checked = values.map((value) => {
            const enabled = Object.values(value.data);
            return enabled[0].allowed;
          });
          if (reduce(and, true, checked)) {
            _this.setState({ checkedA: true });
          } else {
            _this.setState({ checkedA: false });
          }
        })
        .catch((error) => {
          console.error('Error occurred while setting the permission', error);
        });
    }
  };

  updateChildToggle = async (resource, action, onChange) => await onChange(resource.resource, action.action, !action.enabled);

  handleChildToggle = (resource, action, onChange) => {
    const result = this.updateChildToggle(resource, action, onChange);
    result.then((value) => {
      const enabled = Object.values(value.data);
      if (enabled[0].allowed) {
        const unchangedActions = reject(contains(__, [action]), resource.actions);
        const actionEnabled = unchangedActions.map(childAction => childAction.enabled);
        if (reduce(and, true, actionEnabled)) {
          this.setState({ checkedA: true });
        } else {
          this.setState({ checkedA: false });
        }
      } else {
        this.setState({ checkedA: false });
      }
    });
  };

  handleToggleOnClick = (e) => {
    e.stopPropagation();
  };

  setHeaderToggle = (actions) => {
    const actionMap = actions.map(action => action.enabled);
    if (reduce(and, true, actionMap)) {
      this.state.checkedA = true;
    } else {
      this.state.checkedA = false;
    }
  };

  render() {
    const { resource, readOnly, classes, onChange } = this.props;

    return (
      <li>
        <React.Fragment>
          <ExpansionPanel>
            <ExpansionPanelSummary className={classes.nested1} expandIcon={<ExpandMoreIcon />}>
              <ul className={classes.permissionRow}>
                <li style={{ width: '100%' }}>
                  <Typography variant="headline">
                    {resource.resource.split('_').join(' ')}
                  </Typography>
                  <Typography variant="subheading">{resource.description}</Typography>
                </li>
                <li className={classes.switch} onClick={this.handleToggleOnClick}>
                  <Switch
                    color="primary"
                    checked={this.state.checkedA}
                    onChange={this.handleToggleChange(resource, readOnly, onChange)}
                  />
                </li>
              </ul>
            </ExpansionPanelSummary>
            <Divider style={{ marginTop: '1rem', marginLeft: '4%', width: '93%' }} />
            <ExpansionPanelDetails className={classes.display}>
              {resource.actions.map((action, idx) => (
                <div className={classes.nested1} key={idx}>
                  <ul className={classes.permissionRow}>
                    <li style={{ width: '100%' }}>
                      <Typography variant="body2">{action.action}</Typography>
                      <Typography variant="subheading">{action.description}</Typography>
                    </li>
                    <li className={classes.switch}>
                      <Switch
                        value="checkedA"
                        checked={action.enabled}
                        onChange={() => !readOnly && this.handleChildToggle(resource, action, onChange)
                        }
                        color="primary"
                      />
                    </li>
                  </ul>
                  <Divider className={classes.gutterBottom} />
                </div>
              ))}
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </React.Fragment>
      </li>
    );
  }
}

Permission.propTypes = {
  resource: PropTypes.object.isRequired,
  readOnly: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default withStyles(style)(Permission);
